export class SyncAll {
  public static readonly type = '[Notifications] SyncAll';
}
